export default __webpack_public_path__ + "static/media/date-onclick.1d304c3d.svg";